import { render } from "./DomainList.vue?vue&type=template&id=7f316ecb&scoped=true"
import script from "./DomainList.vue?vue&type=script&lang=js"
export * from "./DomainList.vue?vue&type=script&lang=js"

import "./DomainList.vue?vue&type=style&index=0&id=7f316ecb&lang=scss&scoped=true"
import "./DomainList.vue?vue&type=style&index=1&id=7f316ecb&lang=css"
script.render = render
script.__scopeId = "data-v-7f316ecb"

export default script